import React from "react";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import { FaPlus, FaTrash } from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";

const AlarmUsers = ({ users = [], setUsers }) => {
    const normalizeId = (value) => {
        if (!value) return "";

        const clean = value.replace(/\D/g, "");

        return clean.padStart(3, "0");
    };

    const onChangeUser = (index, field, value) => {
        const updated = [...users];

        if (field === "id") {
            const newId = normalizeId(value);
            const exists = updated.some((u, i) => u.id === newId && i !== index);

            if (exists) {
                projectUtils.swalErrorMessage("", "á existe um usuário com esse ID");
                return;
            }

            updated[index].id = newId;
        } else {
            updated[index][field] = value;
        }

        setUsers(updated);
    };

    const addUser = () => {
        setUsers([...users, { id: "", name: "" }]);
    };

    const removeUser = (index) => {
        setUsers(users.filter((_, i) => i !== index));
    };

    return (
        <div className="mt-4">
            <h4 className="font-semibold mb-3 border-b border-gray-200">
                Usuários
            </h4>

            { users.map((u, i) => (
                <div key={i} className="grid grid-cols-12 gap-4 mb-3">
                    <InputForm
                        id={`user_id-${i}`}
                        label="ID *"
                        type="text"
                        value={u.id}
                        classNameWrapper="col-span-1"
                        onChange={(e) =>
                            onChangeUser(i, "id", e.target.value)
                        }
                    />

                    <div className="col-span-11 flex items-end gap-2">
                        <InputForm
                            id={`user_name-${i}`}
                            label="Nome *"
                            value={u.name}
                            classNameWrapper="flex-1"
                            onChange={(e) =>
                                onChangeUser(i, "name", e.target.value)
                            }
                        />

                        <Button target="danger" onClick={() => removeUser(i)}>
                            <FaTrash />
                        </Button>
                    </div>
                </div>
            ))}

            <Button onClick={addUser}>
                <FaPlus /> Adicionar usuário
            </Button>
        </div>
    );
};

export default AlarmUsers;